import { flexRender } from "@tanstack/react-table";
import '../../App.css';
import { SkeletonRow } from '../skeletons/skeletonrow';
import { Button } from '../ui/button';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../ui/table";

// skeletonRows is used for the amount of rows of skeletonloader to display during isLoading

export function DataTable({ table, isLoading, columns, skeletonRows }) {
    return (
        <div>
            <div className="rounded-md border bg-white">
                <Table>
                    <TableHeader>
                        {table.getHeaderGroups().map(headerGroup => (
                            <TableRow key={headerGroup.id}>
                                {headerGroup.headers.map(header => {
                                    return (
                                        <TableHead
                                            style={{
                                                width: header.getSize() !== 150 ? header.getSize() : undefined,
                                                minWidth: header.column.columnDef.minSize,
                                                maxWidth: header.column.columnDef.maxSize,
                                            }}
                                            className={header.column.columnDef.meta?.headerClassName}
                                            key={header.id}>
                                            {header.isPlaceholder
                                                ? null
                                                : flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}
                                        </TableHead>
                                    )
                                })}
                            </TableRow>
                        ))}
                    </TableHeader>
                    <TableBody>
                        {isLoading ? (
                            <SkeletonRow columns={columns.length} rows={skeletonRows} />) : (
                            table.getRowModel().rows?.length ? (
                                table.getRowModel().rows.map(row => (
                                    <TableRow
                                        key={row.id}
                                        data-state={row.getIsSelected() && "selected"}
                                        className={table.options.meta?.getRowStyles ? table.options.meta.getRowStyles(row) : ""}
                                    >
                                        {row.getVisibleCells().map(cell => (
                                            <TableCell
                                                style={{
                                                    width: cell.column.getSize() !== 150 ? cell.column.getSize() : undefined,
                                                    minWidth: cell.column.columnDef.minSize,
                                                    maxWidth: cell.column.columnDef.maxSize,
                                                }}
                                                key={cell.id}
                                                className={cell.column.columnDef.meta?.headerClassName}
                                            >
                                                {cell.column.id === 'name' ? (
                                                    <>
                                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                    </>
                                                ) : (
                                                    flexRender(cell.column.columnDef.cell, cell.getContext())
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={columns.length} className="h-24 text-center">
                                        Inget hittades.
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                    </TableBody>
                </Table>
            </div>
            {table.getState().pagination.pageSize !== 9999 && table.getPageCount() > 1 &&
                <div className="flex items-center justify-end space-x-2 py-4">
                    <div className="flex w-[100px] items-center justify-center text-sm font-medium">
                        Sida {table.getState().pagination.pageIndex + 1} av{" "}
                        {table.getPageCount()}
                    </div>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => table.previousPage()}
                        disabled={!table.getCanPreviousPage()}
                    >
                        Föregående
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => table.nextPage()}
                        disabled={!table.getCanNextPage()}
                    >
                        Nästa
                    </Button>
                </div>
            }
        </div>
    );
}
